<div *ngFor="let item of items" [ngSwitch]="item.Content">    

    <app-notification *ngSwitchCase="'#candidatedecide'" [ctaLabel]="texts.decideCta[language]" (click)="startChat('decide')">
        {{ texts.decide[language] }}
    </app-notification>

    <app-notification *ngSwitchCase="'#candidatestatus'" [ctaLabel]="texts.statusCta[language]" (click)="startChat('status')">
        {{ texts.status[language] }}
    </app-notification>

    <app-notification *ngSwitchCase="'#candidatefeedback'" [ctaLabel]="texts.feedbackCta[language]" (click)="startChat('feedback')">
        {{ texts.feedback[language] }}
    </app-notification>
    
</div>